import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import ungaSlide1 from '../assets/images/eventsPage/unga.png'
import ispadSlide2 from '../assets/images/eventsPage/ispad.png'
import hygieiaSlide3 from '../assets/images/eventsPage/hygenia.png'
import diabetesRoundtable from '../assets/images/eventsPage/diabetesRoundatable.png'
import 'swiper/css'
import 'swiper/css/pagination'

const slides = [
  {
    quote: `“On 27 September 2024, Dure launched CRe-AIT to global health and climate leaders, policymakers, and innovators, showcasing how the platform integrates climate, health, and community data to build more resilient health systems. Attendees saw how the dashboard maps climate events such as floods against health infrastructure vulnerabilities, supported by images submitted by community health workers, and how the AI-powered chatbot provides real-time, practical guidance — for example, helping a pregnant woman safely adjust her birth plan during a flood. Discussions with participants from Africa and the Caribbean underscored the urgent need for real-time data and predictive analytics as climate disasters increasingly disrupt healthcare delivery, with CRe-AIT recognised as a valuable tool to strengthen systems and prepare for future risks ”`,
    event: '79th UNGA – New York ',
    source: '',
    image: ungaSlide1,
  },
  {
    quote: `“At ISPAD 2024 in Lisbon, Dure Technologies proudly launched its AI-based chatbot for Type 1 Diabetes (T1D) — an innovation designed to serve as a one-stop solution for families, caregivers, healthcare providers, and researchers. Powered by cutting-edge AI and backed by ISPAD guidelines, CDIC, Harvard, and IDF datasets, the chatbot provides timely, evidence-based support to children living with T1D, particularly in low- and middle-income countries. The event, organised by ISPAD and the International Diabetes Federation (IDF), brought together global leaders committed to improving T1D care for children worldwide, and reinforced Dure’s mission to deliver cost-effective, sustainable, and scalable digital health solutions. ”`,
    event: 'End TB, ISPAD, 2024',
    source: '',
    image: ispadSlide2,
  },
  {
    quote: `“As part of NDTV–Dettol India’s Banega Swasth India Season 11 campaign, Dure Technologies launched Hygieia for Good Hygiene, a generative AI-powered WhatsApp chatbot designed to make hygiene education fun and interactive for children. Introduced alongside campaign ambassador Ayushmann Khurrana, the tool teaches good hygiene practices through engaging lessons, quizzes, and rewards, while promoting handwashing and awareness of disease-causing pathogens. Available in seven languages (English, Hindi, Tamil, Telugu, Kannada, Odia, and Gujarati), Hygieia for Good Hygiene ensures accessibility for children and families across India. Building on Dure’s global experience developing AI-enabled learning tools, the chatbot creates personalised learning paths to maximise engagement and learning outcomes, helping to foster healthier habits for the next generation. ”`,
    event: 'Hygieia for Good Hygiene: 2024',
    source: '',
    image: hygieiaSlide3,
  },
   {
    quote: `“The IDF Roundtable on AI and Diabetes Care brought together experts from IDF, Harvard, WHO, FIND, and Dure Technologies to discuss how AI can make diabetes care more effective, equitable, and patient-centered. Speakers emphasized that AI must be locally adapted, responsibly scaled, and used to empower patients and health workers alike. The session concluded with a shared call for “responsible and humble AI” that strengthens data systems and ensures access to quality diabetes care worldwide.”`,
    event: 'International Diabetes Foundation Round table',
    source: '',
    image: diabetesRoundtable,
  },
]

const Assembly = () => {
  return (
    <Box sx={{ width: '100%', backgroundColor: '#fff' }}>
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={1}
        style={{ width: '100%' }}
      >
        {slides.map((item, index) => (
          <SwiperSlide key={index}>
            <Grid
              container
              spacing={0}
              sx={{ flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }}
            >
              {/* Left Text Section */}
              <Grid size={{ xs: 12, md: 5 }} className="order-2">
                <Box sx={{ px: { xs: 3, md: 8 }, py: 6 }} className="assemblyArticles">
                  <Typography
                    variant="body1"
                    sx={{ fontStyle: 'italic', color: '#333', mb: 3, fontSize: '14px' }}
                    className='eventDescription'
                  >
                    {item.quote}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 'bold', color: '#69009f', mb: 1, letterSpacing: '0.69px' }}
                  >
                    {item.event}
                  </Typography>

                  <Typography variant="body2" sx={{ color: '#444' }}>
                    {item.source}
                  </Typography>

                  <Box></Box>
                </Box>
                
              </Grid>

              {/* Right Background Image Section */}
              <Grid size={{ xs: 12, md: 7 }}>
                <Box
                  sx={{
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: { xs: 300, md: 500 },
                  }}
                />
              </Grid>
            </Grid>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  )
}

export default Assembly
